 
import { lmsClient } from "api";

const SupplierInvoiceService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

SupplierInvoiceService.getSupplierInvoiceSearchInvoiceService = function (data) {
  const userInputIndex = data?.pageIndex || 0;
  const decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: data?.pageSize,
    pageIndex: decrementIndex,
    nameSupplier: data?.nameSupplier,
    branchId: data?.branchId,
    supplierId: data?.supplierId,
  };
  return lmsClient({
    url: `/lms/InvoiceSupplier/SearchListInvoiceSupplier?${buildQuery(params)}`,
    method: "get",
  });
};

SupplierInvoiceService.getSearchListSupplierService = function (data) {
  const userInputIndex = data?.pageIndex || 0;
  const decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: data?.pageSize,
    pageIndex: decrementIndex,
    nameSupplier: data?.nameSupplier,
    branchId: data?.branchId,
    startDate: data?.startDate,
    endDate: data?.endDate,
    invoiceNo: data?.invoiceNo,
  };
  return lmsClient({
    url: `/lms/InvoiceSupplier/SearchListSupplier?${buildQuery(params)}`,
    method: "get",
  });
};

SupplierInvoiceService.getSupplierInvoiceSearchInvoiceApprovalService = function (data) {
  const userInputIndex = data?.pageIndex || 0;
  const decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: data?.pageSize,
    pageIndex: decrementIndex,
    nameSupplier: data?.nameSupplier,
    branchId: data?.branchId,
    startDate: data?.startDate,
    endDate: data?.endDate,
    invoiceNo: data?.invoiceNo,
  };
  return lmsClient({
    url: `/lms/InvoiceSupplier/SearchListApprovalInvoiceSupplier?${buildQuery(params)}`,
    method: "get",
  });
};

SupplierInvoiceService.addInvoiceSupplierServer = function (data) {
  return lmsClient({
    url: `/lms/InvoiceSupplier/add`,
    method: "POST",
    data: data,
  });
};

SupplierInvoiceService.putInvoiceSupplierApprovalServer = function (data) {
  return lmsClient({
    url: `/lms/InvoiceSupplier/ApproveInvoiceSupplier`,
    method: "PUT",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

SupplierInvoiceService.getSearchListInvoiceSupplierSoftCopyService = function (data) {
  const userInputIndex = data?.pageIndex || 0;
  const decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: data?.pageSize,
    pageIndex: decrementIndex, 
    invoiceNo: data?.invoiceNo,
  };
  return lmsClient({
    url: `/lms/InvoiceSupplier/SearchListInvoiceSupplierSoftCopy?${buildQuery(params)}`,
    method: "get",
  });
};

SupplierInvoiceService.getSearchListInvoiceSupplierDocSoftCopyValidateService = function (data) {
  const userInputIndex = data?.pageIndex || 0;
  const decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: 10000,
    pageIndex: decrementIndex, 
    invoiceNo: data?.invoiceNo,
    applicationId: data?.applicationId,
  };
  return lmsClient({
    url: `/lms/InvoiceSupplier/SearchListInvoiceSupplierDocSoftCopyValidate?${buildQuery(params)}`,
    method: "get",
  });
};

SupplierInvoiceService.getSearchlistDetailInvoiceViewService = function (data) {
  const userInputIndex = data?.pageIndex || 0;
  const decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {
    pageSize: data?.pageSize || 10,
    pageIndex: decrementIndex, 
    invoiceNo: data?.invoiceNo,
    applicationId: data?.applicationId,
  };
  return lmsClient({
    url: `/lms/InvoiceSupplier/searchlistDetailInvoiceView?${buildQuery(params)}`,
    method: "get",
  });
};

export default SupplierInvoiceService;
